const sizeToCss = (size) => {
  if (typeof size === "number") {
    return `${size}px`;
  }
  return size;
};
const pxToRem = (px) => `${px / 16}rem`;
export {
  pxToRem,
  sizeToCss
};
//# sourceMappingURL=index.js.map
